import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('bringozPaddingZeros', bringozPaddingZeros);

function bringozPaddingZeros() {
  return function (n, len, defaultVal) {

    if (defaultVal === undefined) {
      defaultVal = '';
    }

    if (n) {
      if (_.isString(n)) {
        n = _.toNumber(n);
      }

      if (parseInt(n) !== n) {
        return n.toFixed(len);
      } else {
        return n;
      }

    } else return defaultVal;


    // Old version:

    // if (!n) {
    //   return '';
    // }
    //
    // var num = parseInt(n, 10);
    // len = parseInt(len, 10);
    // if (isNaN(num) || isNaN(len)) {
    //     return n;
    // }
    // num = '' + num;
    // while (num.length < len) {
    //     num = '0' + num;
    // }
    //
    // return num;
  };
}
